import { useQuery } from "react-query";

import http from "../../services/httpService";
import Util from "../../util/util";
import useLeagueSeason from "../queryResults/useLeagueSeason";
import useUrls from "../useUrls";

/**
 *
 * @param league
 * @param leagueSeason
 * @param apiUrl
 * @param pageNum
 * @param limit
 * @returns {function(): Promise<*>}
 */
const getMessageBoard =
  (league, leagueSeason, apiUrl, pageNum, limit) => async () => {
    console.log(
      `getMessageBoard(season=${leagueSeason.obj.season}, pageNum=${pageNum}) called...`
    );

    const config = Util.addTokenToHeaders();
    const { data } = await http.get(
      `${apiUrl}/leagues/${league.getIdOrSlug()}/${
        leagueSeason.obj.season
      }/message-board?pageNum=${pageNum}&limit=${limit}`,
      config
    );

    console.log(
      `getMessageBoard(season=${leagueSeason.obj.season}, pageNum=${pageNum}) response data:`
    );
    console.log(data);

    return data;
  };

export default function useQueryMessageBoard(pageNum, limit) {
  const { league, leagueSeason } = useLeagueSeason();
  const { apiUrl } = useUrls();

  return useQuery(
    ["league/message-board", leagueSeason?.obj?.id, pageNum, limit],
    getMessageBoard(league, leagueSeason, apiUrl, pageNum, limit),
    {
      enabled: !!leagueSeason,
      refetchOnWindowFocus: true,
    }
  );
}
